import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=35fc662f&scoped=true&lang=pug"
import script from "./Camera.vue?vue&type=script&lang=ts"
export * from "./Camera.vue?vue&type=script&lang=ts"
import style0 from "./Camera.vue?vue&type=style&index=0&id=35fc662f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc662f",
  null
  
)

export default component.exports